/**
 * KYVERA sticky mobile Add to Cart bar.
 * Shows once the real product form's Add to Cart button has scrolled out of
 * view. Price stays in sync with Dawn's native variant selection via the
 * existing `variant-change` pubsub event (published by product-info.js) —
 * no polling, no duplicated cart/variant logic, no extra network requests.
 */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents !== 'number') return '';
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.KyveraMoneyFormat || '${{amount}}');

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' || opt === null ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) return '0';

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function init(bar) {
    var targetSectionId = bar.getAttribute('data-observe-target');
    var targetSection = document.getElementById(targetSectionId);
    var trigger = bar.querySelector('[data-kyvera-sticky-atc-trigger]');
    var priceEl = bar.querySelector('[data-kyvera-sticky-atc-price]');
    if (!targetSection || !trigger) return;

    var realButtonId = trigger.getAttribute('data-target-form');
    var realButton = document.getElementById(realButtonId);

    trigger.addEventListener('click', function () {
      var currentRealButton = document.getElementById(realButtonId);
      if (currentRealButton) {
        currentRealButton.click();
      }
    });

    // product-info.js skips publishing variantChange entirely when the
    // selected option combination has no matching variant (it calls
    // setUnavailable() and returns early), so the pubsub subscription below
    // never fires for that case. Mirror the real button's disabled state and
    // label directly so the sticky bar can't stay showing a clickable
    // "Add to cart" for an unavailable/sold-out selection.
    function syncButtonState() {
      var currentRealButton = document.getElementById(realButtonId);
      if (!currentRealButton) return;
      var isDisabled = currentRealButton.hasAttribute('disabled');
      trigger.disabled = isDisabled;
      trigger.setAttribute('aria-disabled', String(isDisabled));

      var realLabel = currentRealButton.querySelector('span');
      var labelText = realLabel && realLabel.textContent.trim();
      if (labelText) {
        trigger.textContent = labelText;
      }
    }

    if (realButton && 'MutationObserver' in window) {
      syncButtonState();
      var buttonObserver = new MutationObserver(syncButtonState);
      buttonObserver.observe(realButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // Keep price in sync with the real, native variant selection.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && priceEl) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || !event.data.variant) return;
        if (String(event.data.sectionId) !== bar.getAttribute('data-section-id')) return;
        priceEl.textContent = formatMoney(event.data.variant.price);
      });
    }

    if (!('IntersectionObserver' in window)) {
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
          } else if (entry.boundingClientRect.top < 0) {
            bar.classList.add('is-visible');
          } else {
            bar.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0 }
    );

    io.observe(targetSection);
  }

  document.querySelectorAll('[data-kyvera-sticky-atc]').forEach(init);
})();

